<template>
  <section class="section" id="f2l-section">
    <!-- Filter Buttons -->
    <filter-buttons
      :filters="filterDefinitions"
      :active-filter="activeFilter"
      @filter-change="setFilter"
    />

    <!-- Algorithm Grid -->
    <div class="grid-container">
      <!-- Info Card -->
      <div class="grid-item info-card">
        <div class="exampleText">
          <h2 class="fsize24 mainColor"><b>F2L</b></h2>
          <p>First 2 Layers</p>
          <p>
            <b>[SX] = R U R'<span class="mainColor2"> U'</span></b>
          </p>
          <p>
            <b>[sh] = R' F R F'</b>
          </p>
          <a href="#home-section">Go to the top</a><br />
          <a href="#oll-section">Go to OLL</a><br />
          <a href="#pll-section">Go to PLL</a>
          <p>
            <br />
            <b>Check tips so you don't need to learn algorithms!!</b>
          </p>
        </div>
      </div>

      <!-- Algorithm Cards -->
      <algorithm-card
        v-for="algo in visibleAlgorithms"
        :key="algo.id"
        :number="algo.number"
        :image="algo.image"
        :algorithm="algo.algorithm"
        :scramble="algo.scramble"
        :scramble-class="algo.scrambleClass"
        :additional-algorithm="algo.additionalAlgorithm"
        :tips="algo.tips"
      />
    </div>
  </section>
</template>

<script setup>
import { f2lAlgorithms, filterDefinitions } from './data/f2lData';
import { useAlgorithmFilter } from './composables/useAlgorithmFilter';
import AlgorithmCard from './F2LCard.vue';
import FilterButtons from './FilterButtons.vue';

const { activeFilter, visibleAlgorithms, setFilter } = useAlgorithmFilter(
  f2lAlgorithms,
  filterDefinitions
);
</script>
<style>
a:visited {
  color: #f08200; /* Add this to keep visited links orange */
}

a:active {
  color: #f08200; /* Keep orange when clicking */
}
</style>
